import React from 'react';
import s from './Toast.module.css';

export default function Toast({ message, visible, type = 'success' }) {
  return (
    <div className={`${s.wrap} ${s[type]} ${visible ? s.show : ''}`}>
      {type === 'success' && <div className={s.dot} />}
      {message}
    </div>
  );
}
